import { render, staticRenderFns } from "./AdminTrainingBrand.vue?vue&type=template&id=21fda75a&scoped=true"
import script from "./AdminTrainingBrand.vue?vue&type=script&lang=js"
export * from "./AdminTrainingBrand.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainingBrand.vue?vue&type=style&index=0&id=21fda75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fda75a",
  null
  
)

export default component.exports